import { handleErrorResponse } from "../actions/message"
import { DELETE_COURT_URL, LIST_COURTS_URL, SAVE_COURT_URL } from "../constants/url.constants"
import { serviceAPI } from "./service"

export const getFacilityCourts = () => {
  return serviceAPI.get(LIST_COURTS_URL)
    .then((response) => {
        return response.data
    }).catch(error => {
        handleErrorResponse(error)
    })
}

export const saveCourt = (data) => {
  return serviceAPI.post(SAVE_COURT_URL, data)
    .then((response) => {
      return response.data
    })
    .catch(error => handleErrorResponse(error))
}

export const deleteCourt = (courtId) => {
  return serviceAPI.post(DELETE_COURT_URL + courtId)
  .then(response => {
    return response.data
  })
  .catch(error => handleErrorResponse(error))
}